// extracted by mini-css-extract-plugin
export default {"aboutContent":"About_aboutContent__YecSI","aboutHolder":"About_aboutHolder__4ChoH","aboutText":"About_aboutText__epbwg","about":"About_about__6ibv3"};